import { Row, Col, Form, Button, Tab, Table } from "react-bootstrap";
import Css from './Customer.module.css';
import { useEffect, useState } from "react"
import { AddCommar, ConvertDateTimeToText, ConvertDateToText } from "components/MyControl";

export default function InvoiceDetails({ data = [] }) {
    const [dataDetails, setDataDetails] = useState([]);

    useEffect(() => {
        setDataDetails(data);
    }, [data]);

    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content}>
                <div className={Css.Header}>
                    <h6>Invoice Details</h6>
                </div>
                <div className={Css.Content}>
                    <div className="table-responsive">
                        <Table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th></th>
                                    <th>หมายเลข PO</th>
                                    <th>ชื่อลูกค้า</th>
                                    <th>แพ็คเกจ</th>
                                    <th>วันที่ทำรายการ</th>
                                    <th>วันที่ครบกำหนดชำระ</th>
                                    <th>ราคาแพ็คเกจ</th>
                                    <th>จำนวนที่ชำระ</th>
                                    <th>วันที่ชำระ</th>
                                    <th>ตรวจสอบชำระ</th>
                                    <th>ตรวจสอบโดย</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataDetails.map((obj, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{obj.quontation_number}</td>
                                                <td>{obj.company_name}</td>
                                                <td>{obj.package_master_name_short}</td>
                                                <td>{ConvertDateTimeToText(obj.create_date)}</td>
                                                <td>{ConvertDateTimeToText(obj.due_date)}</td>
                                                <td className="text-end">{AddCommar(obj?.grand_total_sub_withholding_tax?.toFixed(2))}</td>
                                                <td className="text-end">{AddCommar(obj?.paid_amount?.toFixed(2))}</td>
                                                <td>{ConvertDateTimeToText(obj.paid_date)}</td>
                                                <td>{obj.is_audit == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                    : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                <td>{obj.audit_by}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
            <div className={Css.Footer + ' d-none'}>
                <a href={'#'}>View Full Plan</a>
            </div>
        </div>
    )
}